import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countGroupMatches',
  pure: false,
  standalone: false,
})
export class CountGroupMatchesPipe implements PipeTransform {
  transform(
    columns: any[][], // * group['properties'] - array of columns
    searchText: string,
    filterEnabled: boolean = true,
  ): number {
    if (!filterEnabled || !searchText || !columns) {
      // ! Return -1 to indicate "not filtering" (show everything)
      return -1;
    }

    const searchLower = searchText.toLowerCase();
    let totalCount = 0;

    for (const column of columns) {
      for (const lineProperties of column) {
        totalCount += lineProperties.filter((prop: any) =>
          prop.propertyLabel?.toLowerCase().includes(searchLower),
        ).length;
      }
    }

    return totalCount;
  }
}
